import { render, staticRenderFns } from "./AddressScopeTable.vue?vue&type=template&id=6dece4e4&"
import script from "./AddressScopeTable.vue?vue&type=script&lang=js&"
export * from "./AddressScopeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports